function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function loadCSS( url ) {
    var css = document.createElement("link");
    css.setAttribute("rel", "stylesheet");
    css.setAttribute("type", "text/css");
    css.setAttribute("href", url);
    document.getElementsByTagName("head")[0].appendChild(css);
}

function loadScript ( url, callback ) {
    if (document.querySelectorAll( `script[src = "${url}"]` ).length > 0) {
        return;
    }
    var script = document.createElement( "script" );
    script.type = "text/javascript";

    script.setAttribute( 'src', url );
    document.head.appendChild( script );
    if (callback) {
        script.onload = function() {
            callback()
        };
    }
    return this;
}

document.addEventListener("DOMContentLoaded", function (event) {
    $('.only-mob-list').append($('.header-top__nav ul').clone())
    // $('#menu_cat').prepend($('.change-locale').clone())

    // const locale = localStorage.getItem('locale');
    // if (locale) {
    //     $(`[data-locale="${locale}"]`).addClass('active');
    // } else {
    //     $('[data-locale="RU"]').addClass('active');
    // }
    //
    // $('[data-locale]').on('click', function(){
    //     const locale = $(this).attr('data-locale');
    //     localStorage.setItem('locale', locale);
    //     location.reload();
    // })

    $('[name="switch-lang"]').on('change', function() {
        const url = $(this).closest('.lang-switcher').find('.inactive').attr('data-url');
        const locale = $(this).closest('.lang-switcher').find('.inactive').attr('data-locale');

        setSessionLocale(locale, url);
    });

    $('.change-locale > a').on('click', function(e){
        e.preventDefault();

        setSessionLocale($(this).attr('data-locale'), $(this).attr('href'));
    });

    function setSessionLocale(locale, url) {
        $.ajax({
            url: '/blocks/set_session_locale.php',
            type: 'POST',
            data: {
                locale: locale
            },
        }).done(function(){
            window.location.href = url;
        });
    }


    $('.header-burger').click(function () {
        $('.catalog-menu').toggleClass('open');
    });
    $('.close-menu').click(function () {
        $('.header-burger').trigger('click');
    });



    $(document).click(function (e) {
        let target = $(e.target);
        if (!target.closest(".header-center__row, .header-bottom *").length) {
            $('.catalog-menu').removeClass('open');
        }
    });


    function toggleDesc(descName,descHiddenHeight) {

        const descHeight = $(descName).height(); // full height of element

        if (descHeight > descHiddenHeight) {
            // set default height and overflow - max-height for working transition
            $(descName).css({"max-height": descHiddenHeight, "overflow": "hidden"});

            // add hide-it class
            $(descName).addClass("hide-it");

            // add buttons
            $(descName).after(`<div class="text-center py-2 hide-box-top">
                                 <button class="descShow btn-arrow">
                                     <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8 15L1 8L8 1" stroke="#363636" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </button> 
                                <button class="descHide btn-arrow" style="display: none;">
                                     <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8 15L1 8L8 1" stroke="#363636" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </button>
                                </div>
                               `);

            // Toggle height and buttons
            $(".descShow").click(function () {
                $(descName).removeClass("hide-it");
                $(descName).css("max-height", descHeight);
                $('.descHide').toggle();
                $(this).toggle();
                $('.hide-box-top').addClass('hide');
            });
            $(".descHide").click(function () {
                $(descName).addClass("hide-it");
                $(descName).css("max-height", descHiddenHeight);
                $('.descShow').toggle();
                $(this).toggle();
                $('.hide-box-top').removeClass('hide');

            });
        }
    }

    toggleDesc('#basic-desc',250);



    $('.arrowSpan').click(function () {
        $(this).toggleClass('arrowSpan--active');
        $(this).next('ul').slideToggle();
    })

    $('[data-view]').on('click', function(e){
        e.preventDefault();
        setCookie('catalog-view-as', $(this).attr('data-view'), 7);
        location.reload(true);
    });

    const $searchDropdown = $('.search-wrap .dropdown');

    $('.selected', $searchDropdown).on('click', function(e) {
        e.preventDefault();
        $('.list', $searchDropdown).toggleClass('is-active');
    });

    $('[data-type]', $searchDropdown).on('click', function(e) {
        e.preventDefault();
        const type = $(this).attr('data-type');
        const name = $(this).text();

        $('[name="type"]', $searchDropdown).val(type);
        $('.selected', $searchDropdown).text(name);
        $('[data-type]', $searchDropdown).removeClass('active');
        $(this).addClass('active');
        $('.list', $searchDropdown).removeClass('is-active');

        if( $('.search').hasClass('open-results') ) {
            $('#inpsearch').trigger('keyup');
        }
    });

    $(document).on('click', function(e){
        var target = $(e.target);
        if (!target.is('.search-wrap .dropdown, .search-wrap .dropdown *')) {
            $('.list', $searchDropdown).removeClass('is-active');
        }
    });

    // Load-more

    class LoadMore {
        constructor(params) {
            const {button, listCls, itemCls} = params;
            this.itemCls = itemCls;
            this.listCls = listCls;
            this.buttonCls = button;
            this.list = $(listCls);
            this.loadMoreButton = $(button);
            this.activePages = [];

            this.pushCurrentPage()
            this.initListeners();
        }

        initListeners() {
            $(document).on('click', this.buttonCls, () => {
                this.loadMoreButton = $(this.buttonCls);
                this.list = $(this.listCls);
                this.loadItems();
            });

            $(window).on('filters-loaded', () => this.pushCurrentPage());
        }

        pushCurrentPage() {
            this.activePages.push($('li.active', '.digits').attr('data-page'));
        }

        loadItems() {
            this.loadMoreButton.prop('disabled', true).addClass('in-progress');
            $('[data-area="products"]').addClass('is-loading');

            const $nextPagePagination = $('li.active:last', '.digits').next();
            const nextPageURL = $nextPagePagination.find('a').attr('href');

            $.get(nextPageURL, data => {
                const $page = $(data);
                const $items = $page.find(this.itemCls);
                const $pagination = $page.find('.digits').html();

                this.list.append($items);

                $('a[rel=buy]').css('cursor','pointer');

                this.loadMoreButton.prop('disabled', false).removeClass('in-progress');

                $('.digits').html($pagination);

                this.activePages.push($nextPagePagination.attr('data-page'));

                this.activePages.forEach(page => {
                    $(`li[data-page=${page}]`, '.digits').addClass('active');
                });

                if ($('li.active:last', '.digits').next().length === 0) {
                    $('.load-more').remove();
                }

                $('[data-area="products"]').removeClass('is-loading');

                $(window).trigger('products-loaded');
            });
        }
    }

    const $blogList = $('.blog-list');

    if ($blogList.length) {
        new LoadMore({
            button: '.load-more-button--blog',
            listCls: '.blog-list',
            itemCls: '.blog-list .blog-item'
        });
    }

    const $goodsList = $('.goods');

    if ($goodsList.length) {
        new LoadMore({
            button: '.load-more-button--products',
            listCls: '.goods',
            itemCls: '.goods .thumb'
        });
    }
});
